module.exports = [{"type":"title","text":"2024-05-23"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續新增接口：查詢持倉和維持保證金率。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-05-23.json
// module id = KSJz
// module chunks = 3